<nav class="w-[17rem] bg-white h-screen shadow-[0_0_200px_rgba(0,0,0,0.05)] flex flex-col">
  <div class="py-5 px-4 border-b border-gray-100">
    <div class="flex flex-col items-center font-bold text-sm leading-tight text-gray-800 pl-1.5">
      <img src="./assets/images/FSGlogo.svg" alt="Logo" class="w-[85px] h-[91px] object-contain" />      
    </div>
  </div>
  <ul class="list-none p-0 m-0 overflow-y-auto">
    @for (item of sidebarItems; track item) {
      <li [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }" class="m-0">
        <a [routerLink]="item.route" class="flex items-center no-underline text-gray-600 py-3 px-5 transition-all duration-300 text-sm">
          <img [src]="item.route === '/user/csr' ? ((router.url === '/user/csr' || router.url.startsWith('/user/csr/')) ? item.activeIcon : item.icon) : (router.url.startsWith(item.route) ? item.activeIcon : item.icon)" alt="{{ item.label }}" class="w-5 h-5 mr-3" />
          <span>{{ item.label }}</span>
        </a>
      </li>
    }
  </ul>
</nav>
